<template>
  <div class="grid-column-start-2_sm grid-column-end-4_md">
    <header class="my2">
      <h1 class="font-size-8">Ready?</h1>
      <h2>It&rsquo;s time to play with your numbers.</h2>
    </header>
    <div>
      <router-link
        :to="{ name: 'dashboard', query: { s: '1' } }"
        :class="'button large-button full-button_mb accent-button'">Let&rsquo;s go<span class="visuallyhidden"> and use Nimber</span></router-link>
    </div>
  </div>
</template>

<script>
import * as firebase from 'firebase'
import { mapGetters } from 'vuex'
import TextInput from '../../livewires/TextInput.vue'
import Overlay from '../../livewires/Overlay.vue'

export default {
  components: {
    lwTextInput: TextInput,
    lwOverlay: Overlay
  },
  data () {
    return {
      fullName: '',
      title: ''
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'team',
      'organization'
    ])
  },
  methods: {
    addPerson () {
      this.$store.dispatch('saveState', false)
      const name = this.fullName.split(' ')

      const payload = {
        fullName: this.fullName,
        firstName: name.slice(0, -1).join(' '),
        lastName: name.slice(-1).join(' '),
        title: this.title,
        organization: this.organization.id,
        owner: this.user.id,
        created: firebase.default.firestore.FieldValue.serverTimestamp(),
        updated: firebase.default.firestore.FieldValue.serverTimestamp(),
        archived: false
      }
      this.$store.dispatch('addPerson', payload)
    }
  }
}
</script>
